import axios from "axios";
import dayjs from "dayjs";
import { toast } from "react-toastify";

// export const isValidEmail = (email) => {
//   // Define a regular expression pattern for email validation.
//   const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return pattern.test(email);
// };

// export const isValidPhone = (phone) => {
//   const pattern = /^\d{10,10}$/;
//   return pattern.test(phone);
// };

export const isValidPassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasNonalphas = /\W/.test(password);
  const isValidLength = password.length >= 8;

  return (
    hasUpperCase && hasLowerCase && hasNumbers && hasNonalphas && isValidLength
  ); // Include hasNonalphas if you require special characters
};

// Calculate 18 years ago from today
export const eighteenYearsAgo = dayjs().subtract(18, "year");

export const isValidEmail = (email) => {
  // Define a regular expression pattern for email validation.
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email);
};

// utils
export const normalizePhone = (s = "") => s.replace(/\D/g, ""); // strip non-digits

export const isValidPhone = (phone) => {
  const digits = normalizePhone(phone);
  // allow 10 digits, or 11 if leading '1'
  if (/^\d{10}$/.test(digits)) return true;
  if (/^1\d{10}$/.test(digits)) return true;
  return false;
};

export const validatePassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasNonalphas = /\W/.test(password);
  const isValidLength = password.length >= 8;

  return (
    hasUpperCase && hasLowerCase && hasNumbers && hasNonalphas && isValidLength
  ); // Include hasNonalphas if you require special characters
};

export const sendEmailVerification = async (
  email,
  isAgency = false,
  firstName = "",
  lastName = ""
) => {
  // alert("send email verification");
  try {
    const requestData = {
      email: email,
      isAgency: isAgency,
      firstName: firstName,
      lastName: lastName,
    };

    const response = await axios.post(
      `${import.meta.env.VITE_BACKEND_URL}/auth/email-verification/send`,
      requestData,
      {
        headers: {
          // Authorization: accessToken,
        },
      }
    );

    console.log("response: ", response);

    return response;
  } catch (error) {
    console.error("Error occurred while sending verification email: ", error);
    return null;
  }
};

export const verifyAndFetchUserRoles = async (email) => {
  try {
    const requestData = {
      email: email,
    };

    const response = await axios.post(
      `${import.meta.env.VITE_BACKEND_URL}/auth/role-verification`,
      requestData,
      {
        headers: {
          // Authorization: accessToken,
        },
      }
    );

    // console.log("response: ", response);

    return response;
  } catch (error) {
    console.error("Error occurred while sending verification email: ", error);
    return null;
  }
};

// Convert an object to a query string
export const toQueryString = (params) => {
  return new URLSearchParams(params).toString();
};

export const generateAddressSignature = (street1, city, state, zipcode) => {
  return [
    normalizeAddressComponent(street1),
    normalizeAddressComponent(city),
    normalizeAddressComponent(state),
    normalizeAddressComponent(zipcode),
  ]
    .filter(Boolean)
    .join(",");
};

export const normalizeAddressComponent = (str = "") => {
  return str.toLowerCase().trim().replace(/\s+/g, " ").replace(/[.,]/g, "");
};

export const normalizeUnit = (rawUnit = "") => {
  if (!rawUnit) return "";

  return rawUnit
    .toUpperCase()
    .replace(/\b(APT|APARTMENT|SUITE|STE|UNIT|#)\b/g, "UNIT") // normalize label
    .replace(/[^\w\s\-]/g, "") // remove punctuation
    .replace(/\s+/g, " ") // collapse multiple spaces
    .trim()
    .replace(/UNIT\s*0*(\d+)/, "Unit $1"); // remove leading 0s from numbers
};

// export const showErrorToast = (text) => {
//   toast.error(text, {
//     position: "top-center",
//     autoClose: 5000,
//     hideProgressBar: false,
//     closeOnClick: true,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "colored",
//   });
// };
